module.exports = __webpack_public_path__ + "img/form-task-icon.503a8651.svg";